import { render } from "./ProductManager.vue?vue&type=template&id=33274901"
import script from "./ProductManager.vue?vue&type=script&lang=js"
export * from "./ProductManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__